// O selo do informe do legado (feature 012) — um texto só, para as três telas.
//
// "informado pelo banco em 11/09/2026" aparece na averbadora, na carteira do
// banco e nos contratos do servidor. Três cópias da frase seriam três chances
// de uma tela dizer "pela instituição" e outra "pelo credor" para o mesmo fato.

import type { DadosInformadosDoContrato } from "@atlas/sdk";

export type { DadosInformadosDoContrato };

const DATA_BR = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

/** "informado pela consignatária em dd/mm/aaaa" ou "informado pela averbadora em …". */
export function rotuloInformadoPor(d: DadosInformadosDoContrato): string {
  const quem = d.papel === "averbadora" ? "pela averbadora" : "pela consignatária";
  const em = Number.isNaN(new Date(d.em).getTime()) ? d.em : DATA_BR.format(new Date(d.em));
  return `informado ${quem} em ${em}`;
}

/** Versão curta, para caber ao lado do número numa célula. */
export function seloInformadoPor(d: DadosInformadosDoContrato): string {
  return d.papel === "averbadora" ? "informado pela averbadora" : "informado pela consignatária";
}

/** Por que a célula mostra "—": a mesma explicação em toda tela. */
export const TITULO_LEGADO_SEM_DADOS =
  "Contrato legado: a Atlas não tem a cédula, então não conhece o valor solicitado nem a taxa. Eles aparecem quando o credor os informar.";
